import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Home from './components/Home';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import ResidentialServices from './components/ResidentialServices';
import CommercialServices from './components/CommercialServices';
import PropertyManagementPage from './components/PropertyManagementPage';
import TenantPlacementPage from './components/TenantPlacementPage';
import MaintenanceServicesPage from './components/MaintenanceServicesPage';
import FinancialReportingPage from './components/FinancialReportingPage';
import RealEstateInvestmentPage from './components/RealEstateInvestmentPage';
import LegalCompliancePage from './components/LegalCompliancePage';
import ServiceAreasPage from './components/ServiceAreasPage';
import ServicesOverviewPage from './components/ServicesOverviewPage';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/residential" element={<ResidentialServices />} />
          <Route path="/commercial" element={<CommercialServices />} />
          <Route path="/services" element={<ServicesOverviewPage />} />
          <Route path="/services/property-management" element={<PropertyManagementPage />} />
          <Route path="/services/tenant-placement" element={<TenantPlacementPage />} />
          <Route path="/services/maintenance-services" element={<MaintenanceServicesPage />} />
          <Route path="/services/financial-reporting" element={<FinancialReportingPage />} />
          <Route path="/services/real-estate-investment" element={<RealEstateInvestmentPage />} />
          <Route path="/services/legal-compliance" element={<LegalCompliancePage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="*" element={
            <motion.main
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <Home />
            </motion.main>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;